module.exports = __webpack_public_path__ + "img/arrow-left.9d3187b0.svg";